<template>
  <div class="table-wrapper">
    <el-table
      :data="tableData"
      border
      style="height: calc(100% - 54px)" 
    >
      <el-table-column
        prop="name"
        align="center"
        label="权限名"
      />
      <el-table-column
        prop="code"
        align="center"
        label="权限标识"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        prop="remarks"
        align="center"
        label="描述"
      />
      <el-table-column label="操作" width="500">
        <template #default="{ row }">
          <slot :row="row"></slot>
        </template>
      </el-table-column>
    </el-table>

    <section class="pageination" style="margin: 0">
      <el-pagination
        @current-change="handlePageChange"
        :current-page="page.pageNumber"
        :page-size="page.pageSize"
        layout="prev, pager, next"
        :total="total"
      />
    </section>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      page: {
        pageSize: 10,
        pageNumber: 1,
      },
    };
  },
  mounted() {},
  methods: {
    handlePageChange(val) {
      this.page.pageNumber = val
      this.$emit('handle-page-change')
    },
  },
};
</script>

<style scoped lang="less">
.table-wrapper {
  margin: 20px 5px 0 5px;
}
</style>
